// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"287":"df3a4f85","355":"7356374c","658":"107481b0","787":"32d2f0b8","865":"d923f52a"}[chunkId] + ".chunk.js";
};